import { PowerTypeNames } from "app/store/general/constants";

export const PodType = {
  LXD: PowerTypeNames.LXD,
  VIRSH: PowerTypeNames.VIRSH,
} as const;
